import { createApp } from "vue";
import { createPinia } from "pinia";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import App from "./App.vue";
import { vuetify } from "./plugins/vuetify";
import { createAppRouter } from "./router";
import { loadConfig, renderBootError } from "./config";
import { useConfigStore } from "./stores/config";
import { useAuthStore } from "./stores/auth";
import { createApiClient } from "./api/client";

/**
 * El ORDEN acá importa y cada paso depende del anterior:
 *
 *  1. config.json  — todo lo demás necesita las URLs del IDP y de la API
 *  2. pinia        — los stores tienen que existir antes de usarlos
 *  3. auth.init()  — construye el UserManager y restaura la sesión guardada
 *  4. api client   — sus interceptores consultan el store de autenticación
 *  5. router.isReady() — resuelve la ruta inicial y su guard ANTES de pintar,
 *     lo que elimina el parpadeo de la pantalla de login que veía un usuario
 *     con sesión válida
 *  6. mount
 */
async function bootstrap() {
  const config = await loadConfig();

  const app = createApp(App);
  app.use(createPinia());

  useConfigStore().set(config);
  await useAuthStore().init(config.oidc);
  createApiClient(config.api.url);

  const router = createAppRouter();
  app.use(router);
  app.use(vuetify);

  await router.isReady();

  app.mount("#app");
}

bootstrap().catch((err) => {
  console.error("[bootstrap] falló el arranque", err);
  renderBootError(err);
});
